/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type SubscriptionInterval = "Monthly" | "Yearly" | "%future added value";
export type TeamMemberRole = "Admin" | "Member" | "%future added value";
export type UrnType = "Date" | "Email" | "Event" | "FlowState" | "Guest" | "Org" | "Phone" | "Services" | "Setting" | "Team" | "Teammate" | "TimeZone" | "User" | "WorkOsOrg" | "WorkingGroup" | "WorkingHours" | "%future added value";
export type CreateTeamSubscriptionStripeInput = {
    clientMutationId?: string | null | undefined;
    orgRelayId: string;
    seatCount: number;
    stripePaymentMethodId: string;
    subscriptionInterval: SubscriptionInterval;
    teamId: string;
};
export type CreateTeamSubscriptionStripeMutationVariables = {
    input: CreateTeamSubscriptionStripeInput;
};
export type CreateTeamSubscriptionStripeMutationResponse = {
    readonly createTeamSubscriptionStripe: {
        readonly clientMutationId: string | null;
        readonly team: {
            readonly __typename: string;
            readonly id: string;
            readonly teamId: string;
            readonly teamName: string;
            readonly teamCalendarId: string | null;
            readonly createdBy: {
                readonly id: string;
                readonly type: UrnType | null;
                readonly value: string | null;
            };
            readonly teamMembers: ReadonlyArray<{
                readonly role: TeamMemberRole;
                readonly person: {
                    readonly id: string;
                    readonly userId: string | null;
                    readonly personId: string;
                    readonly primaryCalendarId: string;
                    readonly calendarAliases: ReadonlyArray<string>;
                    readonly redirectPersonId: string | null;
                    readonly profile: {
                        readonly givenName: string | null;
                        readonly familyName: string | null;
                        readonly externalImageUrl: string | null;
                    } | null;
                };
            }>;
            readonly invitedMembers: ReadonlyArray<{
                readonly role: TeamMemberRole;
                readonly person: {
                    readonly id: string;
                    readonly userId: string | null;
                    readonly personId: string;
                    readonly primaryCalendarId: string;
                    readonly calendarAliases: ReadonlyArray<string>;
                    readonly redirectPersonId: string | null;
                    readonly profile: {
                        readonly givenName: string | null;
                        readonly familyName: string | null;
                        readonly externalImageUrl: string | null;
                    } | null;
                };
            }>;
        };
        readonly stripeError: {
            readonly code: string | null;
            readonly message: string | null;
        } | null;
    } | null;
};
export type CreateTeamSubscriptionStripeMutation = {
    readonly response: CreateTeamSubscriptionStripeMutationResponse;
    readonly variables: CreateTeamSubscriptionStripeMutationVariables;
};



/*
mutation CreateTeamSubscriptionStripeMutation(
  $input: CreateTeamSubscriptionStripeInput!
) {
  createTeamSubscriptionStripe(input: $input) {
    clientMutationId
    team {
      __typename
      id
      teamId
      teamName
      teamCalendarId
      createdBy {
        id
        type
        value
      }
      teamMembers {
        role
        person {
          id
          userId
          personId
          primaryCalendarId
          calendarAliases
          redirectPersonId
          profile {
            givenName
            familyName
            externalImageUrl
          }
        }
      }
      invitedMembers {
        role
        person {
          id
          userId
          personId
          primaryCalendarId
          calendarAliases
          redirectPersonId
          profile {
            givenName
            familyName
            externalImageUrl
          }
        }
      }
    }
    stripeError {
      code
      message
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        } as any
    ], v1 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v2 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "role",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "concreteType": "OrgPerson",
            "kind": "LinkedField",
            "name": "person",
            "plural": false,
            "selections": [
                (v1 /*: any*/),
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "userId",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "personId",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "primaryCalendarId",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "calendarAliases",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "redirectPersonId",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserProfile",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "givenName",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "familyName",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "externalImageUrl",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ], v3 = [
        {
            "alias": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "CreateTeamSubscriptionStripePayload",
            "kind": "LinkedField",
            "name": "createTeamSubscriptionStripe",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clientMutationId",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "Team",
                    "kind": "LinkedField",
                    "name": "team",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                        },
                        (v1 /*: any*/),
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "teamId",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "teamName",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "teamCalendarId",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "Urn",
                            "kind": "LinkedField",
                            "name": "createdBy",
                            "plural": false,
                            "selections": [
                                (v1 /*: any*/),
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "type",
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "value",
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "TeamMember",
                            "kind": "LinkedField",
                            "name": "teamMembers",
                            "plural": true,
                            "selections": (v2 /*: any*/),
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "TeamMember",
                            "kind": "LinkedField",
                            "name": "invitedMembers",
                            "plural": true,
                            "selections": (v2 /*: any*/),
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "StripeError",
                    "kind": "LinkedField",
                    "name": "stripeError",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "code",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "message",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        } as any
    ];
    return {
        "fragment": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Fragment",
            "metadata": null,
            "name": "CreateTeamSubscriptionStripeMutation",
            "selections": (v3 /*: any*/),
            "type": "Mutation",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": (v0 /*: any*/),
            "kind": "Operation",
            "name": "CreateTeamSubscriptionStripeMutation",
            "selections": (v3 /*: any*/)
        },
        "params": {
            "cacheID": "87c8136d510b87f8363e1ef52fcf295b",
            "id": null,
            "metadata": {},
            "name": "CreateTeamSubscriptionStripeMutation",
            "operationKind": "mutation",
            "text": "mutation CreateTeamSubscriptionStripeMutation(\n  $input: CreateTeamSubscriptionStripeInput!\n) {\n  createTeamSubscriptionStripe(input: $input) {\n    clientMutationId\n    team {\n      __typename\n      id\n      teamId\n      teamName\n      teamCalendarId\n      createdBy {\n        id\n        type\n        value\n      }\n      teamMembers {\n        role\n        person {\n          id\n          userId\n          personId\n          primaryCalendarId\n          calendarAliases\n          redirectPersonId\n          profile {\n            givenName\n            familyName\n            externalImageUrl\n          }\n        }\n      }\n      invitedMembers {\n        role\n        person {\n          id\n          userId\n          personId\n          primaryCalendarId\n          calendarAliases\n          redirectPersonId\n          profile {\n            givenName\n            familyName\n            externalImageUrl\n          }\n        }\n      }\n    }\n    stripeError {\n      code\n      message\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '2acf5d45ef15a9e6c9e5ca59181667ed';
export default node;
